import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import {
  collection, collectionGroup, onSnapshot, addDoc, serverTimestamp, query, orderBy, doc, updateDoc
} from 'firebase/firestore';

const Groups = () => {
  const currentUser = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [groups, setGroups] = useState([]);
  const [newByGroup, setNewByGroup] = useState({});
  const [showCreate, setShowCreate] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [searchText, setSearchText] = useState('');

  const isAdmin = currentUser?.role === 'admin';

  // Загружаем все группы
  useEffect(() => {
    const q = query(collection(db, 'groups'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setGroups(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    }, (error) => console.error('Ошибка загрузки групп:', error));
    return () => unsubscribe();
  }, []);

  // Счётчики новых постов по каждой группе
  useEffect(() => {
    if (!currentUser?.uid) return;
    const unsubscribe = onSnapshot(collectionGroup(db, 'posts'), (snap) => {
      const map = {};
      snap.forEach((d) => {
        const p = d.data();
        if (!p.groupId) return;
        const lastSeen = Number(localStorage.getItem('lastGroupSeen_' + p.groupId) || 0);
        const t = p.createdAt && p.createdAt.toMillis ? p.createdAt.toMillis() : 0;
        if (t > lastSeen) map[p.groupId] = (map[p.groupId] || 0) + 1;
      });
      setNewByGroup(map);
    }, (error) => console.error('Ошибка счётчиков групп:', error));
    return () => unsubscribe();
  }, [currentUser]);

  // Создание группы (только админ)
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await addDoc(collection(db, 'groups'), {
        name: name.trim(),
        description: description.trim(),
        members: [currentUser.uid],
        createdBy: currentUser.uid,
        createdAt: serverTimestamp(),
      });
      setName('');
      setDescription('');
      setShowCreate(false);
    } catch (error) {
      console.error('Ошибка создания группы:', error);
    }
  };

  // Обычные пользователи видят только свои группы + поиск по названию
  const visibleGroups = (isAdmin ? groups : groups.filter((g) => (g.members || []).includes(currentUser?.uid)))
    .filter((g) => {
      const q = searchText.trim().toLowerCase();
      if (!q) return true;
      return (g.name || '').toLowerCase().includes(q) || (g.description || '').toLowerCase().includes(q);
    });

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: 0 }}>Группы</h2>
        {isAdmin && (
          <button
            onClick={() => setShowCreate(!showCreate)}
            style={{ padding: '10px 16px', background: showCreate ? '#ccc' : '#4a90e2', color: showCreate ? '#333' : '#fff', border: 'none', borderRadius: '20px', cursor: 'pointer', fontWeight: 600 }}
          >
            {showCreate ? '✖ Отмена' : '➕ Создать группу'}
          </button>
        )}
      </div>

      {/* Поиск группы */}
      <input
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="🔍 Поиск группы по названию..."
        style={{ width: '100%', padding: '10px 15px', marginBottom: '15px', border: '1px solid #ddd', borderRadius: '20px', boxSizing: 'border-box', background: 'rgba(255,255,255,0.8)' }}
      />

      {/* Форма создания группы (админ) */}
      {isAdmin && showCreate && (
        <form onSubmit={handleCreate} style={{ background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.4)', padding: '15px', borderRadius: '10px', marginBottom: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Название группы"
            required
            style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box' }}
          />
          <input
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Описание (необязательно)"
            style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box' }}
          />
          <button type="submit" style={{ padding: '10px 20px', background: '#4caf50', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 600 }}>
            Создать
          </button>
        </form>
      )}

      {/* Список групп */}
      {visibleGroups.length === 0 ? (
        <p style={{ color: '#888', textAlign: 'center' }}>
          {isAdmin ? 'Групп пока нет. Создайте первую!' : 'Вы пока не состоите ни в одной группе.'}
        </p>
      ) : (
        visibleGroups.map((g) => (
          <div
            key={g.id}
            onClick={() => navigate('/groups/' + g.id)}
            style={{ display: 'flex', alignItems: 'center', gap: '15px', background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.4)', padding: '15px', borderRadius: '10px', marginBottom: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', cursor: 'pointer' }}
          >
            <div style={{ width: '50px', height: '50px', borderRadius: '10px', background: 'linear-gradient(135deg,#667eea,#764ba2)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flex: '0 0 auto' }}>
              👥
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 4px 0' }}>{g.name}</h3>
              {g.description && <p style={{ margin: '0 0 4px 0', color: '#666', fontSize: '14px' }}>{g.description}</p>}
              <span style={{ fontSize: '12px', color: '#888' }}>Участников: {(g.members || []).length}</span>
            </div>

            {/* СЧЁТЧИК новых постов в этой группе */}
            {(newByGroup[g.id] || 0) > 0 && (
              <span style={{ background: '#ff4d4f', color: '#fff', borderRadius: '12px', padding: '2px 8px', fontSize: '12px', fontWeight: 'bold', minWidth: '22px', textAlign: 'center' }}>
                {newByGroup[g.id]}
              </span>
            )}
            {isAdmin && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const newName = window.prompt('Новое название группы:', g.name);
                  if (newName && newName.trim()) {
                    updateDoc(doc(db, 'groups', g.id), { name: newName.trim() }).catch((err) => console.error(err));
                  }
                }}
                title="Переименовать группу"
                style={{ background: '#f0f2f5', border: 'none', borderRadius: '8px', padding: '6px 10px', cursor: 'pointer', fontSize: '14px' }}
              >✏️</button>
            )}
            <span style={{ color: '#4a90e2', fontSize: '20px' }}>→</span>
          </div>
        ))
      )}
    </div>
  );
};

export default Groups;